import { Input, InputGroup, InputGroupText } from "design-react-kit";
import { useState, useContext } from "react";
import ModalComponent from "../../Components/ModalComponent";
import Repo from "../../Utility/Repo";
import { TokenContext } from "../../Components/TokenContext";
import {
  normalizeMoney,
  toUiMoney,
  clampPercent,
  sanitizeMoneyInput,
} from "../../Utility/money";

function NewRange(props) {
  const apiToken = useContext(TokenContext);
  const [isOpen, toggleModal] = useState(false);
  const [validation, setValidation] = useState(false);
  const [data, setData] = useState({
    name: "",
    min: "",
    max: "",
    percent: "",
    fixedCost: "", // UI con virgola
  });

  const newRangeValidation = () => {
    setValidation(true);
    let ok = true;
    if (!data.name) ok = false;
    if (data.min === null || data.min === "") ok = false;
    if (data.max === null || data.max === "") ok = false;
    if (data.fixedCost === null || data.fixedCost === "") ok = false;
    if (ok) toggleModal(!isOpen);
  };

  const insertRangeAPI = () => {
    const payload = {
      ...data,
      min: data.min !== null && data.min !== "" ? Number(data.min) : null,
      max: data.max !== null && data.max !== "" ? Number(data.max) : null,
      fixedCost: normalizeMoney(data.fixedCost), // numero con punto e 2 decimali
      percent: clampPercent(data.percent),
    };

    Repo.postInsertRange(apiToken, JSON.stringify(payload))
      .then(() => {
        window.location.href = props.subfolder + "/fasce";
      })
      .catch((error) => console.log(error));
  };

  const handlePercentChange = (e) =>
    setData({ ...data, percent: clampPercent(e.target.value) });

  // Non blocca: permette stati intermedi (",", "12,", "12,3", ecc.)
  const handleFixedCostChange = (e) =>
    setData({ ...data, fixedCost: sanitizeMoneyInput(e.target.value) });

  // Formatta a 2 decimali quando esci dal campo
  const handleFixedCostBlur = () =>
    setData((prev) => ({
      ...prev,
      fixedCost: toUiMoney(normalizeMoney(prev.fixedCost)),
    }));

  return (
    <div>
      <h1>Nuova fascia ISEE</h1>
      <div className="clearfix col-lg-8 py-lg-2">
        <p>Inserisci una nuova fascia ISEE</p>
      </div>

      <div className="row mt-3">
        <div className="col-lg-4">
          <Input
            id="first_name"
            required
            label="Nome*"
            type="text"
            name="first_name"
            value={data.name}
            {...(validation &&
              !data.name && {
                infoText: "Il campo non può essere vuoto!",
                className: "text-danger error_div is-invalid",
              })}
            onChange={(e) => setData({ ...data, name: e.target.value })}
          />
        </div>

        <div className="col-lg-4">
          <Input
            id="min_value"
            required
            label="Valore Minimo*"
            type="number"
            name="min_value"
            min={0}
            value={String(data.min ?? "")}
            {...(validation &&
              (data.min === null || data.min === "") && {
                infoText: "Il campo non può essere vuoto!",
                className: "text-danger error_div is-invalid",
              })}
            onChange={(e) => setData({ ...data, min: e.target.value })}
          />
        </div>

        <div className="col-lg-4">
          <Input
            id="max_value"
            required
            label="Valore Massimo*"
            type="number"
            name="max_value"
            min={0}
            value={String(data.max ?? "")}
            {...(validation &&
              (data.max === null || data.max === "") && {
                infoText: "Il campo non può essere vuoto!",
                className: "text-danger error_div is-invalid",
              })}
            onChange={(e) => setData({ ...data, max: e.target.value })}
          />
        </div>
      </div>

      <div className="row mt-2">
        <div className="col-lg-6">
          <label htmlFor="percentage">Percentuale</label>
          <div className="input-number input-number-percentage">
            <Input
              id="percentage"
              required
              type="number"
              name="percentage"
              min={0}
              max={100}
              value={String(data.percent ?? "")}
              onChange={handlePercentChange}
            />
          </div>
        </div>

        <div className="col-lg-6">
          <label htmlFor="fixed_cost">Quota Fissa*</label>
          <InputGroup className="mb-0">
            <InputGroupText>€</InputGroupText>
            <Input
              id="fixed_cost"
              name="fixed_cost"
              type="text"
              inputMode="decimal"
              // niente placeholder per evitare overlay col simbolo €
              value={data.fixedCost ?? ""}
              {...(validation &&
                (data.fixedCost === null || data.fixedCost === "") && {
                  infoText: "Il campo non può essere vuoto!",
                  className: "text-danger error_div is-invalid",
                })}
              onChange={handleFixedCostChange}
              onBlur={handleFixedCostBlur}
            />
          </InputGroup>
        </div>
      </div>

      <div className="row my-2">
        <div className="col-lg-12 text-right">
          <button
            type="button"
            className="btn btn-primary"
            data-toggle="tooltip"
            data-placement="top"
            onClick={newRangeValidation}
            title="Conferma"
          >
            Conferma
          </button>
        </div>
      </div>

      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Inserimento nuova fascia ISEE"
        body="Confermi di voler inserire una nuova fascia ISEE?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={insertRangeAPI}
      />
    </div>
  );
}

export default NewRange;
